/* Support-only enhancements. Tracking remains a native link to the existing tracking page. */
if (!customElements.get('monument-support')) {
  customElements.define('monument-support', class extends HTMLElement {
    connectedCallback() {
      this.setAttribute('data-ready', '');
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const route = this.querySelector('.mgs-logistics');
      const motion = window.matchMedia('(prefers-reduced-motion: no-preference) and (hover: hover) and (pointer: fine)');
      const resetRoute = () => {
        cancelAnimationFrame(this.routeFrame);
        this.routeFrame = null;
        route?.style.removeProperty('--route-x');
        route?.style.removeProperty('--route-y');
      };
      route?.addEventListener('pointermove', event => {
        if (!motion.matches || event.pointerType !== 'mouse') return;
        const rect = route.getBoundingClientRect();
        const x = Math.max(-1, Math.min(1, (event.clientX - rect.left) / rect.width * 2 - 1));
        const y = Math.max(-1, Math.min(1, (event.clientY - rect.top) / rect.height * 2 - 1));
        cancelAnimationFrame(this.routeFrame);
        this.routeFrame = requestAnimationFrame(() => {
          route.style.setProperty('--route-x', `${-y * 6}deg`);
          route.style.setProperty('--route-y', `${x * 9}deg`);
        });
      }, {signal, passive:true});
      route?.addEventListener('pointerleave', resetRoute, {signal});
      route?.addEventListener('pointercancel', resetRoute, {signal});
      motion.addEventListener('change', resetRoute, {signal});
      const setOffset = () => {
        const header = document.querySelector('sticky-header') || document.querySelector('.cc-header');
        const rect = header?.getBoundingClientRect();
        const height = rect ? Math.max(0, Math.min(rect.bottom, rect.height)) : 0;
        this.style.setProperty('--mgs-header-offset', `${Math.ceil(height)}px`);
      };
      let pending = false;
      const scheduleOffset = () => {if (!pending) {pending = true; requestAnimationFrame(() => {pending = false; setOffset();});}};
      window.addEventListener('scroll', scheduleOffset, {signal, passive:true});
      window.addEventListener('resize', scheduleOffset, {signal, passive:true});
      setOffset();
      const jumps = [...this.querySelectorAll('.mgs-jump-nav a')];
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) jumps.forEach(link => {
            const active = link.hash === '#' + entry.target.id;
            link.classList.toggle('mgs-active', active);
            if (active) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        });
      }, {rootMargin:'-20% 0px -60% 0px', threshold:0});
      ['OrderSupport', 'ProductSupport', 'KnowledgeBase', 'FindMe'].forEach(id => {
        const section = this.querySelector('#' + id);
        if (section) this.observer.observe(section);
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.routeFrame);
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}
